<script setup lang="ts">
import { computed } from 'vue';
import { formatTooltip } from "@/utils/formatters";
import { icons } from "@/assets/svg";

const IconUser = icons.UserIcon;

interface UserProps {
  user?: {
    first_name: string; 
    last_name: string;
    media: { original_url: string } | null;
    preview_url: string | null;
  };
  showTooltip?: boolean;
}

const props = withDefaults(defineProps<UserProps>(), {
  showTooltip: false
});

const emit = defineEmits<{
  (e: 'click'): void
}>();

const userFullName = computed(() => {
  if (!props.user) return '';
  return `${props.user.first_name || ''} ${props.user.last_name || ''}`;
});

const getTooltip = computed(() => {
  if (!props.showTooltip || !props.user) return '';
  return formatTooltip({ 
    title: userFullName.value, 
    class: 'small-tooltip' 
  });
});
</script>

<template>
  <img
    v-if="user && (user.media || user.preview_url)"
    :src="user.media?.original_url || user.preview_url || ''"
    @click="emit('click')"
    v-tippy="getTooltip"
    class="rounded-full flex-none object-cover w-full h-full"
  />

  <img
    v-else-if="user"
    @click="emit('click')"
    v-tippy="getTooltip"
    class="rounded-full flex-none object-cover w-full h-full"
    :src="`https://api.dicebear.com/9.x/initials/svg?seed=${user.first_name ? user.first_name.charAt(0) : ''}${user.last_name ? user.last_name.charAt(0) : ''}`"
  />

  <div v-else class="rounded-full flex-none bg-primary-300 w-[24px] h-[24px] flex items-center justify-center text-primary-500">
    <IconUser class="h-[14px] w-[14px] fill-current"></IconUser>
  </div>
</template>
